import React from 'react'
import { withRouter } from 'react-router-dom'
import { Breadcrumb, Button, Card, Icon, Layout, Row, Tabs } from 'antd'
import MemberAvatarView from '../../../elements/Members/MemberAvatarView'
import Password from './Password'
import LeavesCont from '../../../components/People/Leaves/LeavesCont'
import ClaimsCont from '../../../components/People/Claims/ClaimsCont'
import Profile from '../../../components/People/Member/Modal/Profile'
import { get } from 'lodash'

const { TabPane } = Tabs
const { Content } = Layout

class Account extends React.Component {
  state = {
    visible: false,
  }

  render() {
    const { member, formRef, memberFetching } = this.props
    return (
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item>{member.fn}</Breadcrumb.Item>
            </Breadcrumb>
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card
            extra={
              <Button
                icon="form"
                type={'primary'}
                size={'large'}
                style={{ marginLeft: 10, float: 'Right' }}
                onClick={() => {
                  this.setState({
                    visible: true,
                  })
                }}>
                Edit Profile
              </Button>
            }
            title={
              <h1>
                <MemberAvatarView id={member.image} /> {member.fn}
              </h1>
            }>
            <Profile
              member={member}
              loading={memberFetching}
              visible={this.state.visible}
              handleCancel={() =>
                this.setState({
                  visible: false,
                })
              }
            />
            <Tabs
              onChange={(key) => this.props.history.push(key)}
              defaultActiveKey={get(this.props, 'location.hash') || '#password'}>
              <TabPane
                tab={
                  <span>
                    <Icon type="user" />
                    Password
                  </span>
                }
                key="#password">
                <Password ref={formRef} {...this.props} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="calendar" />
                    Leaves
                  </span>
                }
                key="#leave">
                <LeavesCont member={member} option={'personal'} />
              </TabPane>
              <TabPane
                tab={
                  <span>
                    <Icon type="red-envelope" />
                    Claims
                  </span>
                }
                key="#claim">
                <ClaimsCont member={member} option={'personal'} />
              </TabPane>
            </Tabs>
          </Card>
        </Row>
      </Content>
    )
  }
}

export default withRouter(Account)
